import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BasicResponse } from "src/app/core/models/basic-response.model";
import { getConnection, getEndpoint } from "src/app/core/services/functions.service";
import { RequestsService } from "src/app/core/services/requests.service";

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private requestsService: RequestsService, private _http: HttpClient) {

  }

  async findAllStores(): Promise<BasicResponse> {
    let project_id = ''
    switch (getConnection()) {
      case 'JA':
        project_id = '1';
        break;
      case 'JP':
        project_id = '10';
        break;
    }
    const result = await this.requestsService.get(
      `${getEndpoint('listCartonsFormats')}/department/departments-stores/${project_id}`
    );
    return result
  }

  async findAllDeparments(): Promise<BasicResponse> {
    getEndpoint('INFO_LOCATION')
    const result = await this.requestsService.get(
      `${getEndpoint('INFO_LOCATION')}/${getConnection()}/location/deparments?tienda_referencia=true`
    );
    return result
  }

  async findAllCities(codDeparment: string): Promise<BasicResponse> {
    const result = await this.requestsService.get(
      `${getEndpoint('INFO_LOCATION')}/${getConnection()}/location/${codDeparment}/cities`
    );
    return result
  }

  async findAllZones(): Promise<BasicResponse> {
    const result = await this.requestsService.get(
      `${getEndpoint('INFO_LOCATION')}/${getConnection()}/location/zones`
    );
    return result
  }

  async findAllBodegas(cendis: boolean = true): Promise<BasicResponse> {
    const result = await this.requestsService.get(
      `${getEndpoint('INFO_LOCATION')}/${getConnection()}/bodegas?cendis=${cendis}`
    );
    return result
  }

}